import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/lib/router-compat";
import { cn } from "@/lib/utils";
import { DesktopNav } from "../nav/DesktopNav";
import { MobileNav } from "../nav/MobileNav";
import { ScarcityBanner } from "@/components/shared/ScarcityBanner";
import logo from "@/assets/logo.png";

export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={cn(
        "fixed left-0 top-0 z-50 w-full border-b transition-all duration-300",
        scrolled
          ? "border-border/80 bg-background/90 shadow-lg shadow-background/40 backdrop-blur-xl"
          : "border-border/40 bg-background/60 backdrop-blur-md",
      )}
    >
      <ScarcityBanner />

      <div
        className={cn(
          "container mx-auto flex items-center justify-between px-4 transition-all duration-300 md:px-6",
          scrolled ? "py-2.5" : "py-4",
        )}
      >
        <Link to="/" className="group flex items-center gap-2.5" onClick={closeMenu}>
          <img
            src={logo}
            alt="SEOEVOLUTION"
            width={32}
            height={32}
            className={cn(
              "w-auto transition-all duration-300",
              scrolled ? "h-7" : "h-8",
            )}
          />
          <span className="flex flex-col leading-none">
            <span className="text-base font-bold tracking-tight">
              <span className="text-seo-bright">SEO</span>
              <span className="text-foreground">EVOLUTION</span>
            </span>
            <span className="mt-0.5 hidden text-[9px] font-medium uppercase tracking-[0.22em] text-muted-foreground sm:block">
              Agencia SEO &amp; GEO premium
            </span>
          </span>
        </Link>

        <DesktopNav />

        <button
          className="rounded-md p-2 text-foreground transition-colors hover:bg-muted focus:outline-hidden md:hidden"
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-label={isMenuOpen ? "Cerrar menú" : "Abrir menú"}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Hairline degradado premium */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent"
      />

      <MobileNav isOpen={isMenuOpen} onLinkClick={closeMenu} />
    </header>
  );
}
